import { Stack } from '@material-ui/core';
import { Skeleton } from '@mui/material';
import React from 'react';

import { CompanyProfileStyledContainer } from './StyledComponents';

function CompanyProfileSkeleton() {
  return (
    <CompanyProfileStyledContainer component={'section'}>
      <Stack spacing={6} direction={'row'}>
        <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} width={65} />
        <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} width={150} />
      </Stack>
      <Stack direction={'row'}>
        <Skeleton
          variant="rounded"
          sx={{ marginTop: '10px', marginBottom: '50px' }}
          width={500}
          height={60}
        />
      </Stack>
      <Stack spacing={6} direction={'row'}>
        <Skeleton variant="rounded" width={75} height={50} />
        <Skeleton variant="rounded" width={75} height={50} />
        <Skeleton variant="rounded" width={75} height={50} />
        <Skeleton variant="rounded" width={75} height={50} />
      </Stack>
      <Stack spacing={6} direction={'row'} sx={{ marginTop: '30px' }}>
        <Skeleton variant="rounded" width={'100%'} height={300} />
        <Skeleton variant="rounded" width={'100%'} height={300} />
      </Stack>
    </CompanyProfileStyledContainer>
  );
}

export { CompanyProfileSkeleton };
